// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__TxBBF","marginInBetween":"style_marginInBetween___99Yx"};